import React from "react";
const AccountIcon = ({
  title,
  className
}) => {
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, title && /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.095 19.428c-1.055-.626-5.166-2.116-5.595-2.275v-1.848c.502-.309 1.384-1.107 1.49-2.935.386-.226.63-.727.63-1.37 0-.578-.197-1.043-.52-1.294.243-.757.681-2.144.385-3.327C16.138 4.992 14.257 4.5 12.75 4.5c-1.342 0-2.982.391-3.569 1.456-.704-.034-1.095.274-1.29.531-.635.838-.216 2.368.02 3.211-.328.249-.53.717-.53 1.302 0 .643.243 1.144.63 1.37.105 1.828.988 2.626 1.489 2.935v1.849c-.385.143-4.464 1.625-5.583 2.288C2.04 17.405 1 14.782 1 12 1 5.935 5.935 1 12 1c6.066 0 11 4.935 11 11 0 2.776-1.035 5.394-2.905 7.428M12 0C5.384 0 0 5.384 0 12c0 3.18 1.232 6.177 3.469 8.438l.001.001C5.743 22.736 8.772 24 12 24c3.234 0 6.268-1.269 8.542-3.573C22.772 18.166 24 15.174 24 12c0-6.616-5.383-12-12-12"
  }));
};
export default AccountIcon;